import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { actionInventoryInfoAddResource, actionInventoryInfoRemoveResource, } from "../../info/inventory/actionInventoryInfo";
import { TypeActionNursery } from "../actionNursery";
export var epicCultivateRecipeRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionNursery.CultivateRequest), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.ProduceAndCollectOutskirt,
            props: {
                playerId: state$.value.playerInfo.playerId,
                recipeId: action.recipe.recipe.id,
                typeId: IdOutskirtBuildings.Nursery,
            },
        });
    }), retry(), switchMap(function (res) {
        var products = res.product;
        var productIcons = products.map(function (product) { return getResourceIconInfo(product); });
        return from([
            actionInventoryInfoRemoveResource(res.cost),
            actionInventoryInfoAddResource(res.product),
            actionAddPelletsInScreenCenterAnimation(IdOutskirtBuildings.Nursery, productIcons),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/epics/epicCultivateRecipeRequest.ts
// module id = 2031
// module chunks = 3